import classNames from 'classnames';

import BannerCenteredContent from 'components/Banner/BannerCenteredContent';

import TextColorsOptions from './Content/enums';

import type { FallbackProps } from './types';

import useContentStyles from './Content/styles';
import useStyles from './styles';

function BannerWithWallpaperFallback({ contentPosition = 'left' }: FallbackProps) {
  const styles = useStyles({ scaleBgOnMobile: false });
  const contentStyles = useContentStyles({ textColor: TextColorsOptions.white });

  return (
    <div
      className={classNames(styles.root, styles.rootFallback)}
      data-testid="BannerWithWallpaperFallback-test"
    >
      <BannerCenteredContent isPrimary>
        <div className={classNames(styles.wrapper, contentPosition)}>
          {/* CONTENT */}
          <div className={classNames(styles.content, styles.contentFallback)}>
            <div className={classNames(styles.subTitleFallback, contentStyles.strongTitle)}>
              <i className="skeleton" />
            </div>
            <div className={classNames(styles.titleFallback, contentStyles.primaryTitle)}>
              <i className="skeleton" />
            </div>
            <div
              className={classNames(styles.descriptionFallback, contentStyles.descriptionHolder)}
            >
              <i className="skeleton" />
            </div>
          </div>
          {/* ACTION */}
          <div className={classNames(styles.action, styles.actionFallback)}>
            <i className="skeleton" />
          </div>
        </div>
      </BannerCenteredContent>
    </div>
  );
}

export default BannerWithWallpaperFallback;
